import "../../styles/global.css";
import React, { useState, useEffect } from "react";
import { fetchQuestionAverageByQuiz, fetchDemoQuestionAverage, 
         fetchAllSubmissionDates, fetchAllDemoSubmissionDates } from "../../api/overviewApi";
import TrendChart from "./TrendChart";

const Trend = () => {

    const [sessionInfo, setSessionInfo] = useState(null);
    const [trendData, setTrendData] = useState({});

    useEffect(() => {
        const cached = localStorage.getItem('iTOOLS_sessionInfo');
        if (cached) {
            console.log("Using cached session info");
            setSessionInfo(JSON.parse(cached));
        } else {
            console.log("No cached session info found");
            setSessionInfo({ name: "Demo Course" }); // Fallback to demo
        }
    }, []);

    useEffect(() => {
        if (!sessionInfo) return;

        const fetchAverage = sessionInfo.courseId
            ? () => fetchQuestionAverageByQuiz(sessionInfo.courseId)
            : () => fetchDemoQuestionAverage();

        fetchAverage()
            .then((data) => {
                setTrendData(data);
            })
            .catch((error) => {
                console.error("Error fetching trend data:", error);
            });
    }, [sessionInfo]);


    return (
        <div className="wrapper">
            <h1 className="title">CLASS TRENDS OVER TIME</h1>
            <p>The three trend charts below show changes in each measure collected through the reflection surveys. X-axis represent the submitted date of the surveys. You can click on each measure’s legend to mute or unmute it. Hover over a data point to see the exact score. Note that the frequency of data collection varies.</p>
            <TrendChart trendData={trendData} />
        </div>
    );
};

export default Trend;